/* eslint-disable comma-dangle, max-len, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp, semi, space-before-function-paren */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var _require = require("../icon-paths.js"),
    iconPlus = _require.iconPlus,
    iconTrash = _require.iconTrash;

var InfoTip = require("../components/info-tip.jsx");
var InlineIcon = require("../components/inline-icon.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var DropdownEditor = React.createClass({
    displayName: "DropdownEditor",

    propTypes: {
        choices: React.PropTypes.arrayOf(React.PropTypes.shape({
            content: React.PropTypes.string,
            correct: React.PropTypes.bool
        })),
        placeholder: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            placeholder: "",
            choices: [{
                content: "",
                correct: false
            }]
        };
    },

    render: function render() {
        var dropdownGroupName = _.uniqueId("perseus_dropdown_");
        return React.createElement(
            "div",
            { className: "perseus-widget-dropdown" },
            React.createElement(
                "div",
                { className: "dropdown-info" },
                "Dropdown",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "The drop down is useful for making inequalities in a custom format. We normally use the symbols ",
                        "<",
                        ",",
                        " ",
                        ">",
                        ", \u2264, \u2265 (in that order) which you can copy into the choices. When possible, use the \"multiple choice\" answer type instead."
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "dropdown-placeholder" },
                React.createElement("input", {
                    type: "text",
                    placeholder: "Placeholder value",
                    value: this.props.placeholder,
                    onChange: this.onPlaceholderChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This value will appear as the drop down default. It should give the user some indication of the values available in the drop down itself, e.g., Yes/No/Maybe."
                    )
                )
            ),
            React.createElement("div", { className: "clearfix" }),
            React.createElement(
                "ul",
                { className: "dropdown-choices" },
                this.props.choices.map(function (choice, i) {
                    var checkedClass = choice.correct ? "correct" : "incorrect";

                    return React.createElement(
                        "li",
                        { key: "" + i },
                        React.createElement(
                            "div",
                            null,
                            React.createElement("input", {
                                ref: "radio" + i,
                                type: "radio",
                                name: dropdownGroupName,
                                checked: choice.correct ? "checked" : "",
                                onChange: this.onCorrectChange.bind(this, i),
                                value: i
                            }),
                            React.createElement("input", {
                                type: "text",
                                ref: "editor" + i,
                                onChange: this.onContentChange.bind(this, i),
                                className: checkedClass,
                                value: choice.content
                            }),
                            React.createElement(
                                "a",
                                {
                                    href: "#",
                                    className: "simple-button orange",
                                    onClick: this.removeChoice.bind(this, i)
                                },
                                React.createElement(
                                    "span",
                                    { className: "remove-choice" },
                                    React.createElement(InlineIcon, iconTrash)
                                )
                            )
                        )
                    );
                }, this)
            ),
            React.createElement(
                "div",
                { className: "add-choice-container" },
                React.createElement(
                    "a",
                    {
                        href: "#",
                        className: "simple-button orange",
                        onClick: this.addChoice
                    },
                    React.createElement(InlineIcon, iconPlus),
                    " Add a choice",
                    " "
                )
            )
        );
    },

    onPlaceholderChange: function onPlaceholderChange(e) {
        var placeholder = e.target.value;
        this.props.onChange({ placeholder: placeholder });
    },

    onCorrectChange: function onCorrectChange(choiceIndex) {
        var choices = _.map(this.props.choices, function (choice, i) {
            return _.extend({}, choice, {
                correct: i === choiceIndex
            });
        });
        this.props.onChange({ choices: choices });
    },

    onContentChange: function onContentChange(choiceIndex, e) {
        var choices = this.props.choices.slice();
        var choice = _.clone(choices[choiceIndex]);
        choice.content = e.target.value;
        choices[choiceIndex] = choice;
        this.props.onChange({ choices: choices });
    },

    addChoice: function addChoice(e) {
        e.preventDefault();

        var choices = this.props.choices;
        var blankChoice = { content: "", correct: false };
        this.props.onChange({
            choices: choices.concat([blankChoice])
        }, this.focus.bind(this, choices.length));
    },

    removeChoice: function removeChoice(choiceIndex, e) {
        e.preventDefault();
        var choices = _(this.props.choices).clone();
        choices.splice(choiceIndex, 1);
        this.props.onChange({
            choices: choices
        });
    },

    focus: function focus(i) {
        ReactDOM.findDOMNode(this.refs["editor" + i]).focus();
        return true;
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = DropdownEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/dropdown-editor.jsx
 ** module id = 99
 ** module chunks = 0 1
 **/